import _ from 'lodash'
import { InternalRolesType, ExternalRolesType } from '../utils/costants'
import { NotifyRule } from './notifyRule'
import { ProjectUser, Tenant } from './projectRoles'

export class AppUser {
    userObjectId?: string
    tenant?: Tenant
    projectUserRoleId?: number
    rowKey?: string
    isSelf?: boolean
    id?: string
    name?: string
    email?: string
    company?: string
    country?: string
    role?: Role
    stakeHolderId?: number
    notifications?: NotifyRule[]
    notificationsToBeRemoved?: NotifyRule[]

    constructor( object: any, roles: Role[], assignment?: ProjectUser, tenant?: Tenant){
        this.id = object.userObjectId || object.objectId || object.id;
        this.userObjectId = this.id;
        this.tenant = tenant || object.tenant;
        this.projectUserRoleId = assignment && assignment.projectUserRoleId;
        this.rowKey = `${this.tenant}:${this.userObjectId}:${this.projectUserRoleId || 'unassigned'}`;
        this.name = object.displayName;
        this.email = object.email || object.mail;
        this.company = assignment ? assignment.company || assignment.lastKnownCompany || undefined : undefined;
        this.country = object.country;
        this.role = assignment ? {...roles.find(role => role.name === assignment.roleCode), userRoleId: String(assignment.projectUserRoleId)} : undefined;
        this.notifications = [];
        this.notificationsToBeRemoved = [];
    }  
}

export const mapAdministrationUsers = (directory: any[], assignments: ProjectUser[], tenant: Tenant, roles: Role[]): AppUser[] => {
    const records = [...directory];
    assignments.filter(assignment => assignment.tenant === tenant && !assignment.isDeleted).forEach(assignment => {
        if (!records.some(user => String(user.userObjectId || user.objectId || user.id || '').toLowerCase() === assignment.userObjectId.toLowerCase())) {
            records.push({...assignment, id: assignment.userObjectId});
        }
    });
    return _.flatMap(records, record => {
        const id = record.userObjectId || record.objectId || record.id;
        const active = assignments.filter(assignment => !assignment.isDeleted && assignment.tenant === tenant && id && assignment.userObjectId.toLowerCase() === id.toLowerCase());
        return active.length ? active.map(assignment => new AppUser(record, roles, assignment, tenant)) : [new AppUser(record, roles, undefined, tenant)];
    });
};

export class Role {
    id?: string
    projectId?: string
    azureName?: string
    name?: InternalRolesType | ExternalRolesType
    description?: string
    userRoleId?: string
    constructor (object: any) { 
        this.id = object.id;
        this.azureName = object.displayName;
        this.projectId = (object.displayName && object.displayName.includes('_')) ? object.displayName.split('_')[0] : undefined;
        this.name = (object.displayName && object.displayName.includes('_')) ? object.displayName.split('_')[1] : undefined;
        this.description = object.description;
        this.userRoleId = object.userRoleId;
    }
}


export class UserRoleApi {
    userId?: string
    appRoleId?: string
    appRoleAssignmentId?: string

    constructor(object: AppUser){
        this.userId = object.id;
        this.appRoleId = (object.role) ? object.role.id : undefined;   
        this.appRoleAssignmentId = (object.role) ? object.role.userRoleId : undefined;      
    }
}

export class ExternalUserForm {
    userObjectId?: string
    email?: string
    company?: string
    country?: string
    role?: Role
    notifications?: NotifyRule[]
    errors?: {
        email?: string
        company?: string
        country?: string
        role?: string
    }
    constructor(object?: any) {
        this.email = object.email;
        this.company = object.company;
        this.country = object.country;
        this.role = object.role;
        this.notifications = [];
        this.errors = (object.errors) ? object.errors : { email: undefined, country: undefined, company: undefined, role: undefined};
    }
}

